import { Box } from "@mui/material";
import React from "react";
import BreadcrumbsComponent from "./BreadcrumbsComponent";

const ActionButton = ({ bData, HeadingText, ...rest }) => {
  HeadingText ??= "";

  return (
    <>
      <Box
        sx={{
          pt:1,
          width: 1,
        }}
      >
        <h5 className="ms-4 mt-2">{HeadingText}</h5>
        <div className="ms-4">
          {" "}
          <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
        </div>
      </Box>
    </>
  );
};

export default ActionButton;
